module.exports = __webpack_public_path__ + "img/form-submitted.84b9fdbd.png";